export const NEW_PEN = "SET_NEW_PEN"
export const CAN_EDIT = "CAN_EDIT"
export const SET_PEN_HTML = "SET_PEN_HTML"
export const SET_PEN_CSS = "SET_PEN_CSS"
export const SET_PEN_JS = "SET_PEN_JS"
export const SET_PEN_DESCRIPTION = "SET_PEN_DESCRIPTION" 

export const ADD_JS_CDN = "ADD_JS_CDN";
export const ADD_CSS_CDN = "ADD_CSS_CDN";
// export const ADD_HTML_CDN = "ADD_JS_CDN";

export const REMOVE_JS_CDN = "REMOVE_JS_CDN";
export const REMOVE_CSS_CDN = "REMOVE_CSS_CDN";
// export const REMOVE_JS_CDN = "REMOVE_JS_CDN";


export const SET_EDITOR_MODE = "SET_EDITOR_MODE"   //new, preview mode
export const SET_PEN_TITLE = "SET_PEN_TITLE"

export const SET_CLASS_TAG = "SET_CLASS_TAG";
export const SET_HEAD_STUFF = "SET_HEAD_STUFF"

export const LOAD_PEN = "LOAD_PEN"

export const SET_DEFAULT_PEN = "SET_DEFAULT_PEN" 


// WEBPACK FOOTER //
// ./src/redux/types/penTypes.js